export default __webpack_public_path__ + "static/media/step2.33f7e5ac.png";